export default __webpack_public_path__ + "4b41f2e1dfb505b5fb16fd6462f674a2.svg";